/**
 * When a run started, as people say it: "Today, 2:21 AM", "Yesterday, 9:00 PM" or "Nov 3, 2:21 PM".
 * `now` is passed in by tests. '' for anything that is not a date.
 */
const formatRunTime = (value, now = new Date()) => {
  const ms = Date.parse(value || '');

  if (!Number.isFinite(ms)) {
    return '';
  }

  const date = new Date(ms);
  const time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const dayMs = 24 * 60 * 60 * 1000;

  if (ms >= startOfToday && ms < startOfToday + dayMs) {
    return `Today, ${time}`;
  }

  if (ms >= startOfToday - dayMs && ms < startOfToday) {
    return `Yesterday, ${time}`;
  }

  return `${date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}, ${time}`;
};

export default formatRunTime;
